import CurrencyPaneEditor from './CurrencyPaneEditor';

export default CurrencyPaneEditor;
export { CurrencyPaneEditor };
